import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TaxFormLayer from "../components/TaxFormLayer";

const TaxFormPage = () => {
    return (
        <MasterLayout>
            <TaxFormLayer />
        </MasterLayout>
    );
};

export default TaxFormPage;
